import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    :host {
        display: block;
    }

    sl-dialog::part(panel) {
        width: 100%;
    }

    @media only screen and (max-width: 768px) {
        sl-dialog::part(panel) {
            min-height: 100%;
            min-width: 100%;
        }
    }
`;
